import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import React, { useCallback, useRef } from 'react'
import { ScrollView, StyleSheet, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useFocusEffect, useRouter } from 'expo-router'
import { useIsFocused } from '@react-navigation/native'

import { Header } from '@/components/Mini/Header'
import { DS } from '@/design-system'
import { useStore } from '@/models'
import { events } from '@/models/analytics/analytics-events'
import { DiamondsBalance } from '@/screens/diamonds/components/DiamondsBalance'
import { HowToEarnCard } from '@/screens/diamonds/components/HowToEarnCard'
import { RedeemCard } from '@/screens/diamonds/components/RedeemCard'
import { RecentActivityCard } from '@/screens/diamonds/components/RecentActivityCard'
import { RewardsCard } from '@/screens/diamonds/components/RewardsCard'

export const DiamondsScreen = () => {
  const router = useRouter()
  const {
    analytics: { setEvent }
  } = useStore()
  const scrollRef = useRef<ScrollView>(null)
  const isFocused = useIsFocused()

  useFocusEffect(
    useCallback(() => {
      setEvent(events.diamonds.page_viewed, {})
      scrollRef.current?.scrollTo({ y: 0, animated: false })
    }, [setEvent])
  )

  return (
    <SafeAreaView style={styles.container}>
      {isFocused ? <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} /> : null}
      <Header
        theme={{ icon: 'Global/Black', accent: 'Global/Black' }}
        variant="Heading 3/Medium"
        title="Diamonds"
        showKey={false}
        showDiamonds={false}
        handler={() => router.back()}
      />
      <ScrollView ref={scrollRef} contentContainerStyle={styles.scrollContent}>
        <View style={styles.webWrapper}>
          <DS.Frame gap="24">
            <View style={styles.card}>
              <DiamondsBalance />
            </View>
            {/*<RewardsCard compact />*/}
            <HowToEarnCard compact />
            <RedeemCard compact />
            <RecentActivityCard compact />
          </DS.Frame>
        </View>
      </ScrollView>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: DS.palette['Brand/Cream']
  },
  scrollContent: {
    padding: DS.spacing[24],
    paddingBottom: DS.spacing[48]
  },
  card: {
    backgroundColor: DS.palette['Global/White'],
    borderRadius: DS.spacing[8],
    padding: DS.spacing[16],
    gap: 8
  },
  webWrapper: {
    width: '100%',
    maxWidth: 600,
    alignSelf: 'center'
  }
})
